import { render, staticRenderFns } from "./ThirdPay.vue?vue&type=template&id=1ed92c3b&scoped=true&"
import script from "./ThirdPay.vue?vue&type=script&lang=ts&"
export * from "./ThirdPay.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdPay.vue?vue&type=style&index=0&id=1ed92c3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed92c3b",
  null
  
)

export default component.exports